export const sortAlphabetically = (array = [], sortKey = '') => {
  return array.sort((firstItem, secondItem) => {
    const firstVal = firstItem[sortKey] || '';
    const secondVal = secondItem[sortKey] || '';

    return firstVal.localeCompare(secondVal);
  });
};
